import type React from 'react';

import * as styles from './styles';

import { CaptionDefault } from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';
import cn from '@cobliteam/ui/utils/cn';

export interface ControlButtonProps {
  Icon?: JSX.Element;
  text?: string;
  selected?: boolean;
  disabled?: boolean;
  noHover?: boolean;
  textClassName?: string;
  onClick: () => void;
  children?: React.ReactNode;
  className?: string;
}

export const ControlButton: React.FC<ControlButtonProps> = ({
  Icon,
  text,
  selected,
  disabled,
  noHover,
  textClassName,
  onClick,
  children,
  className,
}) => {
  const handleClick = disabled || selected ? undefined : onClick;

  return (
    <Button
      startIcon={Icon}
      variant="outlined"
      color="secondary"
      size="condensed"
      className={cn(
        'border-gray-light p-0 text-gray-dark hover:border-gray-light',
        selected || disabled
          ? 'bg-gray-lightest text-gray-light hover:text-gray-light'
          : 'bg-white',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        noHover ? '' : 'hover:bg-gray-lightest',
        styles.controlButton,
        className
      )}
      onClick={handleClick}
    >
      {text && (
        <CaptionDefault
          className={`${styles.controlButtonText} ${textClassName || ''}`}
        >
          {text}
        </CaptionDefault>
      )}
      {children}
    </Button>
  );
};
